<template>
    <div>
        <v-card>
            <v-toolbar flat height="90" outlined>
                <v-toolbar-title>
                    <p class="subtitle-1 text-uppercase font-weight-bold ma-0 primary--text" style="white-space: normal">
                        {{ group }}
                    </p>
                    <p class="caption ma-0" style="font-size:  10px !important">GROUP NAME</p>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
        </v-card>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
export default {
    name: 'info',
    props: ['group'],
    computed: {
        ...mapState({
            arrayON: state => state.meters.arrayON,
            arrayUP: state => state.meters.arrayUP,
            arrayDOWN: state => state.meters.arrayDOWN,
            arrayOFF: state => state.meters.arrayOFF,
            arrayOUT: state => state.meters.arrayOUT,
        })
    },
    data() {
        return {
            menu: false,
            status: '',
            signal: false,
            hourConverted: null
        }
    },
    methods: {
        getColor(meter){
            let status = this.arrayUP.find(m => m.circuit === meter)
            if (status != undefined) {this.status='Overconsumption'; return 'orange darken-3'}
            status = this.arrayDOWN.find(m => m.circuit === meter)
            if (status != undefined) {this.status='Underconsumption'; return 'yellow darken-2'}
            status = this.arrayON.find(m => m.circuit === meter)
            if (status != undefined) {this.status='On'; return 'accent'}
            status = this.arrayOFF.find(m => m.circuit === meter)
            if (status != undefined) {this.status='Off'; return 'grey darken-3'}
            status = this.arrayOUT.find(m => m.circuit === meter)
            if (status != undefined) {this.status='Offline'; return 'red'}
        },
        batsignal(s){
            if(s) this.signal=true
            else this.signal=false
        }
    },
}
</script>

<style scoped>
.disp{
    height: 60px;
    width: 150px;
}
</style>